export const isDraftHtmlEmpty = (draftHtml: string): boolean => {
  if (!draftHtml) {
    return true;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(draftHtml, "text/html");
  const nodesToRemove = doc.body.querySelectorAll("#divRplyFwdMsg, #divRplyFwdMsg ~ *");

  nodesToRemove.forEach((node) => {
    node.remove();
  });

  return (doc.body.textContent || "").replace(/[\n\r\t\s]/g, "").length === 0;
};
